import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';

import { URL } from '../../../constant';
import useConceptCheckPlayer from '../../../hooks/useConceptCheckPlayer';
import ConceptCheckPlayerBox from '../../common/iframe/ConceptCheckPlayerBox';

function ResultIncorrect({ result }) {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [, setConceptPopup] = useConceptCheckPlayer();  // 개념확인 팝업
  const handleClick = (type) => {
    let data = {}
    if (type === 'meta') {
      data = {
        url: result.cncpMeta,
        stgNm: result.stgNm,
      };
    } else {
      data = {
        url: result.drilldwCncpMeta,
        stgNm: result.drilldwStgNm,
      };
    }
    setConceptPopup({ 
      url: data.url, 
      title: data.stgNm, 
      stepNm: result?.stepNm,
      thmaNm: result?.thmaNm,
      onOff: true 
    });
  }

  const handlePage = () => {
    console.log("***** 결과 페이지 -> 오답확인 페이지")
    history.push({
      pathname: URL.LEARNING.CHECK_WRONG_ANSWER,
      state: {
        stgCd: result.stgCd,
        lrnEntyScnCd: location.state.lrnEntyScnCd
      }
    })
  }

  const handleConceptCheck = (type) => {
    console.log('***** 결과 페이지 - 개념확인 모달 오픈')
    handleClick(type)
  }

  return (
    <React.Fragment>
      <ConceptCheckPlayerBox />
      <div className="lr-mySB-item item-wrong">
        <p className="lr-mySB-tit">{t("LC_05_07_01.msg014")}</p>
        <button
          className="lr-mySB-txt"
          onClick={handlePage}
        >
          {t("LC_05_07_01.msg015", { t: result.wransrQstCt})}
        </button>
      </div>
      <div className="lr-mySB-item item-concept">
        <p className="lr-mySB-tit">{t("LC_05_07_01.msg016")}</p>
        <span className="lr-mySB-txt">
          <button
            // className="visited"
            onClick={() => handleConceptCheck('meta')}
          >1</button>
          {
            (result?.drilldwCt && result.drilldwCt > 0)
              ? <button onClick={() => handleConceptCheck('drill')}>2</button>
              : null
          }
        </span>
      </div>
    </React.Fragment>
  );
}

export default ResultIncorrect;